(function () {
  function getOriginalTotalElement() {
    return document.querySelector('.cart__total [data-cart-total]');
  }

  function getCheckoutTotalElement() {
    return document.querySelector('button[name="checkout"] [data-cart-total-price]');
  }

  function updateItemsFinalTotal() {
    var originalTotalElement = getOriginalTotalElement();
    var checkoutTotalElement = getCheckoutTotalElement();

    if (!originalTotalElement || !checkoutTotalElement) {
      return;
    }

    var finalTotalText = checkoutTotalElement.textContent.trim();

    if (!finalTotalText) {
      return;
    }

    var finalTotalElement = originalTotalElement.parentElement.querySelector('[data-custom-cart-final-total]');

    if (!finalTotalElement) {
      finalTotalElement = document.createElement('span');
      finalTotalElement.setAttribute('data-custom-cart-final-total', '');
      finalTotalElement.style.fontWeight = '700';
      finalTotalElement.style.marginLeft = '12px';
      originalTotalElement.insertAdjacentElement('afterend', finalTotalElement);
    }

    if (finalTotalElement.textContent.trim() !== finalTotalText) {
      finalTotalElement.textContent = finalTotalText;
    }
  }

  function scheduleUpdate() {
    window.clearTimeout(window.customCartTotalsTimer);
    window.customCartTotalsTimer = window.setTimeout(updateItemsFinalTotal, 300);
    window.setTimeout(updateItemsFinalTotal, 800);
    window.setTimeout(updateItemsFinalTotal, 1500);
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateItemsFinalTotal();

    document.addEventListener('click', scheduleUpdate);
    document.addEventListener('change', scheduleUpdate);

    var observer = new MutationObserver(scheduleUpdate);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  });
})();